import { render, staticRenderFns } from "./CorpSearchBtn.vue?vue&type=template&id=65dd3782&lang=pug"
import script from "./CorpSearchBtn.vue?vue&type=script&lang=js"
export * from "./CorpSearchBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports